import React, { FC } from "react";

type Props = {
  color?: string;
  size?: number;
};

const UserAdminIcon: FC<Props> = ({ color, size = 16 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.99935 7.99984C7.26602 7.99984 6.63824 7.73873 6.11602 7.2165C5.59379 6.69428 5.33268 6.0665 5.33268 5.33317C5.33268 4.59984 5.59379 3.97206 6.11602 3.44984C6.63824 2.92762 7.26602 2.6665 7.99935 2.6665C8.73268 2.6665 9.36046 2.92762 9.88268 3.44984C10.4049 3.97206 10.666 4.59984 10.666 5.33317C10.666 6.0665 10.4049 6.69428 9.88268 7.2165C9.36046 7.73873 8.73268 7.99984 7.99935 7.99984ZM2.66602 13.3332V11.4665C2.66602 11.0887 2.76324 10.7415 2.95768 10.4248C3.15213 10.1082 3.41046 9.8665 3.73268 9.69984C4.42157 9.35539 5.12157 9.09706 5.83268 8.92484C6.54379 8.75262 7.26602 8.6665 7.99935 8.6665C8.73268 8.6665 9.45491 8.75262 10.166 8.92484C10.8771 9.09706 11.5771 9.35539 12.266 9.69984C12.5882 9.8665 12.8466 10.1082 13.041 10.4248C13.2355 10.7415 13.3327 11.0887 13.3327 11.4665V13.3332H2.66602ZM3.99935 11.9998H11.9993V11.4665C11.9993 11.3443 11.9688 11.2332 11.9077 11.1332C11.8466 11.0332 11.766 10.9554 11.666 10.8998C11.066 10.5998 10.4605 10.3748 9.84935 10.2248C9.23824 10.0748 8.62157 9.99984 7.99935 9.99984C7.37713 9.99984 6.76046 10.0748 6.14935 10.2248C5.53824 10.3748 4.93268 10.5998 4.33268 10.8998C4.23268 10.9554 4.15213 11.0332 4.09102 11.1332C4.0299 11.2332 3.99935 11.3443 3.99935 11.4665V11.9998ZM7.99935 6.6665C8.36602 6.6665 8.6799 6.53595 8.94102 6.27484C9.20213 6.01373 9.33268 5.69984 9.33268 5.33317C9.33268 4.9665 9.20213 4.65262 8.94102 4.3915C8.6799 4.13039 8.36602 3.99984 7.99935 3.99984C7.63268 3.99984 7.31879 4.13039 7.05768 4.3915C6.79657 4.65262 6.66602 4.9665 6.66602 5.33317C6.66602 5.69984 6.79657 6.01373 7.05768 6.27484C7.31879 6.53595 7.63268 6.6665 7.99935 6.6665Z"
        fill="#2E2E2E"
      />
    </svg>
  );
};

export default UserAdminIcon;
